import type { ReactNode } from "react";

type BadgeColor = "accent" | "success" | "danger" | "warn" | "info" | "muted";

// Design tokens from tailwind.config.ts
const COLOR_HEX: Record<BadgeColor, string> = {
  accent: "#a855f7",
  success: "#22c55e",
  danger: "#ef4444",
  warn: "#eab308",
  info: "#3b82f6",
  muted: "#666666",
};

interface BadgeProps {
  color?: BadgeColor;
  title?: string;
  children: ReactNode;
}

/** Trailing badge — 20% opacity background, solid text, matching legacy .trailing-badge.
 *  All caps by design for visual consistency with SessionDirectionBadge
 *  (LONG / SHORT / AI SKIP / COOLDOWN). */
export default function Badge({ color = "muted", title, children }: BadgeProps) {
  const hex = COLOR_HEX[color];
  return (
    <span
      className="inline-flex items-center text-[0.7rem] font-medium px-1.5 py-0.5 rounded uppercase"
      style={{ background: `${hex}20`, color: hex }}
      title={title}
    >
      {children}
    </span>
  );
}
